<template>
    <modal name="modal-cart"
           :maxWidth="600"
           :height="'auto'"
           :scrollable="true"
           :clickToClose="false"
           classes="p-2 lg:p-8 shadow-lg rounded">
        <div class="absolute bg-white bg-opacity-50 w-full h-full flex items-center justify-center z-10 left-0 top-0"
             :class="{'hidden': !loadingCheckout}">
            <spinner/>
        </div>

        <icon-close class="absolute right-2 top-2"

                    :w="20"
                    :h="20"
                    @click.native="editList"/>

        <template v-if="!showWhoYouAre">
            <h2 class="text-center">Your Cart</h2>

            <div class="relative">
                <div class="border">
                    <div class="bg-gray-100 flex py-2 lg:py-4">
                        <div class="w-[50%] px-2 lg:px-4 text-primary text-[12px] lg:text-[14px]">List Type / Details
                        </div>
                        <div class="w-[25%] px-2 lg:px-4 text-primary text-[12px] lg:text-[14px]">Leads</div>
                        <div class="w-[25%] px-2 lg:px-4 text-primary text-[12px] lg:text-[14px]">Price</div>
                    </div>

                    <cart-item v-for="item in selects"
                               :key="item.key"
                               :item="item"/>
                </div>

                <div class="flex justify-between btn-actions mt-4">
                    <button class="btn btn-gray bg-fully relative btn-arrow-left"
                            @click="$modal.hide('modal-cart')">
                        <icon-arrow class="lg:left-2 arrow-btn arrow-mirror"
                                    uiobject="old"
                        />
                        Edit this list
                    </button>
                    <button
                        class="group btn btn-blue bg-fully relative btn-arrow-right"
                        @click="checkout">
                        Proceed to checkout
                        <icon-arrow class="lg:right-2 group-hover:text-primary arrow-btn"
                                    uiobject="old"
                                    color="text-white"/>
                    </button>
                </div>
            </div>
        </template>
        <who-you-are v-else/>
    </modal>
</template>

<script>
    import { v4 as uuidv4 } from "uuid";
    import cartItem from "@widget/components/cart/cart-item";
    import WhoYouAre from "@widget/components/who-you-are";

    export default {
        name: "modal-cart",
        components: {
            WhoYouAre,
            cartItem
        },
        computed: {
            selects () {
                let selectedDataForUI = this.$store.getters["widgetData/getSelectedDataForUI"];

                let item = {
                    key: uuidv4(),
                    list_type: selectedDataForUI.audience.title,
                    leads: this.$store.getters["calculateLeads/getQuantity"],
                    price: this.$store.getters["calculateLeads/getPrice"],
                    credit: this.$store.getters["calculateLeads/getCredit"],
                    selects: selectedDataForUI.selects.map(item => ({
                        key: uuidv4(),
                        sensitive: item.sensitive,
                        title: item.title
                    }))
                };
                return [item];
            }
        },
        methods: {
            checkout () {
                this.loadingCheckout = true;

                this.$store.dispatch("widgetData/checkout").then(({ data: { data: response } }) => {
                    if (!this.$widgetConfig.logged) {
                        this.showWhoYouAre = true;
                        this.loadingCheckout = false;
                    } else {
                        window.location.href = `/checkout/create/${response.id}`;
                    }
                });
            },
            editList () {
                this.showWhoYouAre = false;
                this.$modal.hide("modal-cart");
            },
            notLogged () {
                this.showWhoYouAre = true;
            }
        },
        data () {
            return {
                loadingCheckout: false,
                showWhoYouAre: false
            };
        }
    };
</script>
